import { useEffect, useRef, useState } from "react";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import API from "../Api/axiosConfig";
import MyButton from "./MyButton";
import Can from "./Can";
import MyInput from "./Myinput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { useReactToPrint } from "react-to-print";
import { FloatingLabel } from "react-bootstrap";
import Logo from "../logo.svg";
import Alert from "react-bootstrap/Alert";
import { useSettings } from "../context/SettingsContext";

function MyTable({
  resource,
  columns,
  refreshKey,
  method = "get",
  title,
  body = {},
  filters = [],
  appendData = true,
  dateFilter = null,
  button = { text: "", onClick: null, variant: "success", permission: "" },
  component = null,
  invoice = false,
}) {
  const [data, setData] = useState([]);
  const [lastTotalValue, setLastTotalValue] = useState();
  const [loading, setLoading] = useState(true);
  const [filterValues, setFilterValues] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const tableRef = useRef(null);
  const { settings } = useSettings();
  const [balance, setBalance] = useState();
  const [taxBalance, setTaxBalance] = useState();
  useEffect(() => {
    setData([]);
    setCurrentPage(1);
  }, [resource, refreshKey]);

  const bodyString = JSON.stringify(body);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let res;
        const url = `/${resource}?page=${currentPage}`;

        if (method.toLowerCase() === "post") {
          res = await API.post(url, body);
        } else {
          res = await API.get(url);
        }
        let newData = [];
        if (component === "taxesReport") {
          newData = res.data.data.invoices || [];
          setTaxBalance(res.data.data.total_tax)
        } else {
          newData = res.data.data || [];
        }
        // const newData = res.data.data || [];
        const lastTotalValue = res.data.last_total_value || null;
        // console.log(newData);

        if (appendData && currentPage > 1) {
          setData((prevData) => [...prevData, ...newData]);
        } else {
          setData(newData);
        }
        setLastTotalValue(lastTotalValue);

        const paginationData = res.data.pagination;
        if (paginationData) {
          setHasMore(paginationData.current_page < paginationData.last_page);
        } else {
          setHasMore(false);
        }
      } catch (err) {
        console.error(`فشل في جلب ${resource}`, err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [resource, refreshKey, method, currentPage, appendData, bodyString]);
  useEffect(() => {
    if (component === "accountStatement" && data.length > 0) {
      const total = data.reduce(
        (sum, item) => sum + parseFloat(item.value || 0),
        0
      );
      // console.log(data);
      setBalance(`${total < 0 ? `(${total})` : total} : الرصيد الحالي`);
    } else if (component === "accountStatement" && data.length == 0) {
      setBalance(null);
    }
    if (component === "cash" && data.length > 0) {
      // console.log(data);

      // const totalValue = data.reduce(
      //   (sum, item) => item.total_value,
      // );

      const cashType = data[0]?.cash_type === "bank" ? "البنك" : "الخزنة";

      setBalance(
        `${
          lastTotalValue
            ? typeof lastTotalValue === "object"
              ? "UnKnown"
              : lastTotalValue
            : "unKnown"
        } : رصيد ${cashType}`
      );
    }
  }, [data, component]);
  useEffect(() => {
    const today = new Date();

    // أول يوم في الشهر الحالي
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // آخر يوم في الشهر الحالي
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // نحول التاريخ إلى صيغة YYYY-MM-DD بدون UTC
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(lastDay));
  }, []);

  const handleFilterChange = (name, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const filteredData = data.filter((item) => {
    const passesFilters = filters.every((f) => {
      const filterValue = filterValues[f.name];
      if (!filterValue || filterValue === "") return true;
      const cellValue = f.name.includes(".")
        ? f.name.split(".").reduce((acc, key) => acc?.[key], item)
        : item[f.name];
      return cellValue
        ?.toString()
        .toLowerCase()
        .includes(filterValue.toLowerCase());
    });

    if (dateFilter && (dateFrom || dateTo)) {
      const itemDate = dateFilter.field.includes(".")
        ? dateFilter.field.split(".").reduce((acc, key) => acc?.[key], item)
        : item[dateFilter.field];
      if (!itemDate) return false;
      const itemDateObj = new Date(itemDate);
      if (dateFrom) {
        const fromDateObj = new Date(dateFrom);
        if (itemDateObj < fromDateObj) return false;
      }
      if (dateTo) {
        const toDateObj = new Date(dateTo);
        toDateObj.setHours(23, 59, 59, 999);
        if (itemDateObj > toDateObj) return false;
      }
    }
    return passesFilters;
  });
  const handlePrint = useReactToPrint({
    contentRef: tableRef,
    documentTitle: "طباعة الجدول",
    pageStyle: `
      @page {
        size: A4 portrait;
        margin: 10mm;
      }

      body {
        font-family: "Cairo", sans-serif;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        direction: rtl;
        color: #000 !important;
        }

      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
      }

      th, td {
        border: 1px solid black;
        padding: 8px;
        text-align: center;
        color: #000 !important;
        font-size: 13px;

      }
    .print-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    background: white;
    padding: 5px 0;
  }

      th {
        background-color: #e0e0e0 !important;
        color: #000 !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    tr:nth-child(22) {
    height: 80px;
    }
    tr:nth-child(44) {
    height: 80px;
    }
    tr:nth-child(66) {
    height: 80px;
    }
    tr:nth-child(88) {
    height: 80px;
    }
    tr:nth-child(110) {
    height: 80px;
    }
      .no-print {
        display: none !important;
      }
    `,
  });

  return (
    <div className="mt-2">
      <div className="d-flex justify-content-between align-items-end flex-nowrap">
        <div className="d-flex mb-4">
          {button.text && button.permission && (
            <Can permission={button.permission}>
              <MyButton
                text={button.text || "إضافة"}
                variant={button.variant || "success"}
                type="button"
                className="align-self-end"
                onClick={button.onClick}
              />
            </Can>
          )}
          <div className={`no-print align-self-end ${button.text && "ms-4"}`}>
            <button className="btn btn-outline-info" onClick={handlePrint}>
              <FontAwesomeIcon icon={faPrint} />
            </button>
          </div>
        </div>
        {(filters.length > 0 || dateFilter) && (
          <div className="d-flex gap-4 mb-3 flex-wrap flex-grow-1 justify-content-end">
            {filters.map((f, i) => (
              <div key={i} style={{ minWidth: "180px" }}>
                {f.type === "select" ? (
                  <FloatingLabel label={f.label}>
                    <Form.Select
                      className="form-select mb-3"
                      style={{ height: "38px" }}
                      value={filterValues[f.name] || ""}
                      onChange={(e) =>
                        handleFilterChange(f.name, e.target.value)
                      }>
                      {f.options.map((opt, j) => (
                        <option key={j} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                ) : (
                  <MyInput
                    type="text"
                    className="form-control mb-3"
                    value={filterValues[f.name] || ""}
                    label={f.label}
                    onChange={(e) => handleFilterChange(f.name, e.target.value)}
                    placeholder={f.label}
                    style={{ height: "38px" }}
                  />
                )}
              </div>
            ))}

            {dateFilter && (
              <>
                <div
                  className="d-flex align-items-end justify-content-between"
                  style={{ minWidth: "180px" }}>
                  <div className="d-flex gap-4 align-items-start">
                    <div style={{ minWidth: "180px" }}>
                      <MyInput
                        type="date"
                        label={"اِلي"}
                        className="form-control"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                      />
                    </div>
                    <div style={{ minWidth: "180px" }}>
                      <MyInput
                        type="date"
                        label={"من"}
                        className="form-control"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {loading && currentPage === 1 ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}>
          <Spinner animation="border" variant="light" />
        </div>
      ) : (
        <>
          <div ref={tableRef} style={{ color: "#000" }}>
            {component && (
              <div className="text-center">
                <p className="fs-5 fw-medium text-white mb-0">{balance}</p>
              </div>
            )}

            <Table
              striped
              bordered
              hover
              responsive
              className="text-center my-table-container">
              <thead>
                <tr className="bg-transparent ">
                  <th className="bg-transparent " colSpan={columns.length + 1}>
                    <div className="print-header ">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2>{title || "تقرير"}</h2>
                        {settings?.head_company_logo
                          ? settings?.head_company_logo == 1 && (
                              <img
                                src={settings?.company_logo}
                                alt="شعار الشركة"
                                style={{
                                  width: "80px",
                                  height: "auto",
                                  borderRadius: "8px",
                                }}
                              />
                            )
                          : ""}
                      </div>
                      <div className="print-header-section  ">
                        {settings?.head_company_name == 1 && (
                          <div>
                            اسم الشركة : {settings?.company_name || "--"}
                          </div>
                        )}
                        {settings?.head_invoice_address == 1 && (
                          <div className="">
                            العنوان : {settings?.company_address || "--"}
                          </div>
                        )}
                        {/* {invoice && settings?.head_invoice_type == 1 && (
                          <div>نوع الفاتورة :</div>
                        )} */}
                      </div>
                      <div className="print-header-section center"></div>

                      <div className="print-header-section">
                        <div>الهاتف : {settings?.company_phone || "--"}</div>

                        {invoice && settings?.head_invoice_type == 1 && (
                          <div>رقم الفاتورة: 12345</div>
                        )}
                        <p className="">
                          تاريخ الطباعة: {new Date().toLocaleString("ar-EG")}
                        </p>
                      </div>
                    </div>
                    {/* <div className="print-header justify-content-between ">
                      <div className="print-header-section  ">
                        <div>اسم الشركة :</div>
                        <div>العنوان :</div>
                      </div>

                      <div className="print-header-section  ">
                        <div>اسم العميل: محمد أحمد</div>
                      </div>
                    </div> */}
                  </th>
                </tr>

                <tr className="my-table-head">
                  <th>م</th>
                  {columns.map((col, i) => (
                    <th
                      // c
                      key={i}
                      className={
                        col.hideOnPrint ? "no-print my-table-header" : ""
                      }>
                      {col.header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, rowIndex) => (
                    <tr key={rowIndex} className="my-table-content">
                      <td>{rowIndex + 1}</td>
                      {columns.map((col, colIndex) => {
                        let value;
                        if (typeof col.accessor === "function") {
                          value = col.accessor(row, rowIndex);
                        } else if (
                          typeof col.accessor === "string" &&
                          col.accessor.includes(".")
                        ) {
                          value = col.accessor
                            .split(".")
                            .reduce((acc, key) => acc?.[key], row);
                        } else {
                          value = row[col.accessor];
                        }
                        return (
                          <td
                            key={colIndex}
                            className={`my-table-cell ${
                              col.hideOnPrint ? "no-print" : ""
                            }`}>
                            {value ?? "-"}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length + 1} className="text-center">
                      لا توجد بيانات
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="only-print print-footer">
                <tr>
                  <td colSpan={columns.length + 1}>
                    <div className="print-footer only-print">
                      <div className="print-footer-section right">
                        {settings?.foot_tax_number == 1 && (
                          <div>
                            الرقم الضريبي:{" "}
                            {settings?.company_tax_number || "--"}
                          </div>
                        )}
                        {settings?.foot_company_commercial == 1 && (
                          <div>
                            السجل التجاري:{settings?.company_commercial || "--"}{" "}
                          </div>
                        )}
                      </div>
                      {settings?.foot_company_seal == 1 && (
                        <div className="print-footer-section center">
                          <img
                            src={settings?.company_seal}
                            alt="ختم الشركة"
                            style={{
                              width: "80px",
                              height: "auto",
                              borderRadius: "8px",
                            }}
                          />{" "}
                        </div>
                      )}
                      <div className="print-footer-section left">
                        {settings?.foot_company_website == 1 && (
                          <div>
                            الموقع الإلكتروني:
                            {settings?.company_website ||
                              "https://www.facebook.com/"}{" "}
                          </div>
                        )}
                        {settings?.foot_company_email == 1 && (
                          <div>
                            البريد الإلكتروني:{" "}
                            {settings?.company_email || "exampel@info.com"}{" "}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </Table>
            {/* Footer */}
          </div>
          {component === "taxesReport" && filteredData.length > 0 && (
            <Alert
              variant="info"
              className="mt-4 text-center fs-6 fw-bold shadow-sm"
              style={{
                backgroundColor: "#b19bd5",
                color: "#f4f8ffff",
                border: "none",
                textAlign: "center"
              }}>
              إجمالي المستحقات الضريبية :{" "}
              {taxBalance}

            </Alert>
          )}
          {loading && currentPage > 1 && (
            <div className="text-center my-3">
              <Spinner animation="border" variant="light" size="sm" />
              <span className="ms-2">جاري التحميل...</span>
            </div>
          )}

          {hasMore && !loading && (
            <div className="text-center mt-3">
              <Button variant="outline-light" onClick={handleLoadMore}>
                عرض المزيد
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default MyTable;
